import React from 'react'
import '../dist/loadingstyle.css'

const Projectloading = () => {
  return (
        <div className="center">
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        </div>
  )
}

export default Projectloading